import Box, { type BoxProps } from "@mui/material/Box";
import Stack, { type StackProps } from "@mui/material/Stack";
import Typography, { type TypographyProps } from "@mui/material/Typography";
import Head from "next/head";
import type { ReactNode } from "react";
// import { UserGuideLink } from "./UserGuideLink";

export interface PageHeaderProps extends BoxProps {
  title: string;
  hideTitle?: boolean;
  color?: TypographyProps["color"];
  titleTypographyProps?: TypographyProps<"h1">;
  subTitle?: string | string[] | ReactNode;
  subTitleTypographyProps?: TypographyProps;
  TopSlot?: ReactNode;
  RightSlot?: ReactNode;
  rightSlotProps?: BoxProps;
  TitleSlot?: ReactNode;
  titleStackProps?: StackProps;
  updateHeadTitle?: boolean;
}

const templateAreas = `
  "top top"
  "title right"
  "subtitle right"
`;
const templateAreasMobile = `
  "top"
  "title"
  "subtitle"
  "right"
`;

export function PageHeader({
  title,
  hideTitle = false,
  titleTypographyProps,
  subTitle,
  color,
  subTitleTypographyProps,
  TopSlot,
  RightSlot,
  TitleSlot,
  titleStackProps,
  rightSlotProps,
  updateHeadTitle = true,
  ...props
}: PageHeaderProps) {
  return (
    <>
      {updateHeadTitle && (
        <Head>
          <title>{title}</title>
        </Head>
      )}
      <Box
        display="grid"
        gridTemplateAreas={{ xs: templateAreasMobile, sm: templateAreas }}
        mb={2}
        {...props}
      >
        {TopSlot && <Box gridArea="top">{TopSlot}</Box>}
        {RightSlot && (
          <Box gridArea="right" {...rightSlotProps} justifySelf="end">
            {RightSlot}
          </Box>
        )}
        <Stack
          direction="row"
          columnGap={3}
          alignItems="center"
          flexWrap="wrap"
          gridArea="title"
        >
          {!hideTitle && (
            <Typography
              variant="h3"
              component="h1"
              color={color || "text.primary"}
              {...titleTypographyProps}
            >
              {title}
            </Typography>
          )}
          {TitleSlot}
        </Stack>
        {subTitle && (
          <Box gridArea="subtitle">
            {typeof subTitle === "string" ? (
              <Typography
                maxWidth="65ch"
                variant="subtitle1"
                color={color || "text.secondary"}
                {...subTitleTypographyProps}
              >
                {subTitle}
              </Typography>
            ) : (
              subTitle
            )}
          </Box>
        )}
      </Box>
    </>
  );
}
